import { gql } from '@apollo/client';
import CommonFragments from 'features/common/fragments';
import Fragments from './fragments';

export const TEXT_RESOURCE_LIST_QUERY = gql`
  query textResources {
    textResources {
      id
      textResourceCode
    }
  }
`;

export const PAGED_TEXT_RESOURCE_LIST_QUERY = gql`
  query pagedTextResources($pager: PagerInputNew, $context: ContextInput, $filters: TextResourcesFilterInput) {
    pagedTextResources(pager: $pager, context: $context, filters: $filters) {
      total
      context {
        ...context
      }
      values {
        ...textResourceItem
      }
    }
  }
  ${CommonFragments.context}
  ${Fragments.textResourceItem}
`;

export const TEXT_RESOURCE_LIST_FILTERS_QUERY = gql`
  {
    textResourcesFilters @client {
      textResourceCode {
        value
      }
      textResourceLabel {
        value
      }
      fullTextFilter {
        value
      }
    }
  }
`;
